import React from 'react';

const SVG = ({ style = {}, color = 'rgb(84, 157, 255)', on, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} fill={color}>
      <circle cx="50" cy="50" r="46" fill="transparent" strokeWidth={8} />
      <g opacity={on ? 0 : 1}>
        <line x1="18" y1="18" x2="81" y2="81" stroke={color} strokeWidth={9} />
        <path d="M 23,38 L 28,38 63,73 63,81 43,61 23,61" />
        <path d="M 45,35 L 63,17 63,54" />
      </g>
      <path d="M 23,38 L 42,38 63,17 63,81 43,61 23,61" opacity={on ? 1 : 0} />
    </g>
  </svg>
);

export default SVG;
